import { render, staticRenderFns } from "./PatientEdit.vue?vue&type=template&id=791afde7&scoped=true"
import script from "./PatientEdit.vue?vue&type=script&lang=js"
export * from "./PatientEdit.vue?vue&type=script&lang=js"
import style0 from "./PatientEdit.vue?vue&type=style&index=0&id=791afde7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791afde7",
  null
  
)

export default component.exports